import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const STATI = ["Attivo", "In pausa", "Concluso", "Da ricontattare"];

export const emptyOwner = { nome: "", cognome: "", telefono: "", email: "", indirizzo: "", citta: "", note: "", stato: "Attivo" };

const norm = (s) => (s || "").toString().toLowerCase().replace(/\s+/g, " ").trim();
const digits = (s) => (s || "").toString().replace(/\D/g, "");

export const findOwnerDuplicates = (owners, form) => {
  const fn = norm(`${form.nome || ""} ${form.cognome || ""}`);
  const em = norm(form.email);
  const ph = digits(form.telefono);
  return (owners || []).filter((o) => {
    if (fn && norm(`${o.nome} ${o.cognome}`) === fn) return true;
    if (em && norm(o.email) && norm(o.email) === em) return true;
    if (ph && digits(o.telefono) && digits(o.telefono) === ph) return true;
    return false;
  });
};

export const OwnerFields = ({ form, setForm, tid = "owner", showStato = true }) => {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  return (
    <>
      <div className="space-y-1"><Label>Nome *</Label><Input data-testid={`${tid}-nome`} value={form.nome} onChange={set("nome")} /></div>
      <div className="space-y-1"><Label>Cognome</Label><Input data-testid={`${tid}-cognome`} value={form.cognome} onChange={set("cognome")} /></div>
      <div className="space-y-1"><Label>Telefono</Label><Input data-testid={`${tid}-telefono`} value={form.telefono} onChange={set("telefono")} /></div>
      <div className="space-y-1"><Label>Email</Label><Input data-testid={`${tid}-email`} value={form.email} onChange={set("email")} /></div>
      <div className="space-y-1 col-span-2"><Label>Indirizzo</Label><Input data-testid={`${tid}-indirizzo`} value={form.indirizzo} onChange={set("indirizzo")} /></div>
      <div className="space-y-1"><Label>Città / Zona</Label><Input data-testid={`${tid}-citta`} value={form.citta} onChange={set("citta")} /></div>
      {showStato && (
        <div className="space-y-1">
          <Label>Stato</Label>
          <Select value={form.stato} onValueChange={(v) => setForm((f) => ({ ...f, stato: v }))}>
            <SelectTrigger data-testid={`${tid}-stato`}><SelectValue /></SelectTrigger>
            <SelectContent>{STATI.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
      <div className="space-y-1 col-span-2"><Label>Note</Label><Textarea data-testid={`${tid}-note`} value={form.note} onChange={set("note")} /></div>
    </>
  );
};

export const DuplicateOwnerDialog = ({ matches, onUse, onCreateAnyway, onCancel }) => (
  <AlertDialog open={matches.length > 0} onOpenChange={(v) => !v && onCancel()}>
    <AlertDialogContent data-testid="dup-owner-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Possibile proprietario già esistente</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div>
            <span className="block mb-2">Abbiamo trovato clienti simili. Puoi usarne uno esistente oppure creare comunque un nuovo cliente.</span>
            <div className="space-y-1.5">
              {matches.map((m) => (
                <button key={m.id} data-testid={`dup-use-${m.id}`} onClick={() => onUse(m)}
                  className="w-full text-left rounded-lg border border-border p-2.5 hover:border-primary transition-colors">
                  <span className="font-semibold text-foreground">Usa proprietario esistente: {m.nome} {m.cognome}</span>
                  <span className="block text-xs text-muted-foreground">{[m.telefono, m.email].filter(Boolean).join(" · ") || "—"}</span>
                </button>
              ))}
            </div>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Indietro</AlertDialogCancel>
        <AlertDialogAction data-testid="dup-create-anyway" onClick={onCreateAnyway}>Crea comunque nuovo</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
